import { LoginInfo } from './login-info';
import { AuthInfo } from './auth-info';

export abstract class AuthRepository {
  abstract login(username: string, password: string): Promise<LoginInfo>;

  abstract loginCard(serialNumber: string): Promise<LoginInfo>;

  abstract loginUser(token: string, originCode: string): Promise<AuthInfo>;
}
